import { default as _91content_93kt1hGsiECfMeta } from "/home/vsts/work/1/s/pages/[content].vue?macro=true";
import { default as _91fixtureType_93UDHT8Irm3uMeta } from "/home/vsts/work/1/s/pages/[sport]/[sportId]/[fixtureType].vue?macro=true";
import { default as _91sportId_930YbkMQpPA8Meta } from "/home/vsts/work/1/s/pages/[sport]/[sportId].vue?macro=true";
import { default as _91sport_93LQKHQUoxC6Meta } from "/home/vsts/work/1/s/pages/[sport].vue?macro=true";
import { default as book_45a_45bet_45resultsizdxkyjSHxMeta } from "/home/vsts/work/1/s/pages/book-a-bet-results.vue?macro=true";
import { default as contact_45usSgGnAosGsWMeta } from "/home/vsts/work/1/s/pages/contact-us.vue?macro=true";
import { default as dailyjackpotsKBwsVj15pMMeta } from "/home/vsts/work/1/s/pages/dailyjackpots.vue?macro=true";
import { default as esportsm1R3epktOQMeta } from "/home/vsts/work/1/s/pages/esports.vue?macro=true";
import { default as _91event_93zk9vV1UzJJMeta } from "/home/vsts/work/1/s/pages/event/[sport]/[region]/[league]/[event].vue?macro=true";
import { default as _91sport_93NWFKln68cPMeta } from "/home/vsts/work/1/s/pages/event/[sport].vue?macro=true";
import { default as index5uCpQGhJ8kMeta } from "/home/vsts/work/1/s/pages/event/index.vue?macro=true";
import { default as healthgO3FPzNA7uMeta } from "/home/vsts/work/1/s/pages/health.vue?macro=true";
import { default as indexegOWm4p6gtMeta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as jackpotsFEOKkTz2kEMeta } from "/home/vsts/work/1/s/pages/jackpots.vue?macro=true";
import { default as liveyTCRxVARCsMeta } from "/home/vsts/work/1/s/pages/live.vue?macro=true";
import { default as indexWjwOuaJYfCMeta } from "/home/vsts/work/1/s/pages/lobby/[subLobby]/[tab]/index.vue?macro=true";
import { default as _91game_93agPUsgKOwUMeta } from "/home/vsts/work/1/s/pages/lobby/[subLobby]/[type]/[game].vue?macro=true";
import { default as _91subLobby_93gQY47dpIVcMeta } from "/home/vsts/work/1/s/pages/lobby/[subLobby].vue?macro=true";
import { default as loggingLxNRDEOlcmMeta } from "/home/vsts/work/1/s/pages/logging.vue?macro=true";
import { default as luckynumbersBOOPWjF9J6Meta } from "/home/vsts/work/1/s/pages/luckynumbers.vue?macro=true";
import { default as indexh0yOV4UQKBMeta } from "/home/vsts/work/1/s/pages/outrights/index.vue?macro=true";
import { default as regZoxP0uSQu5Meta } from "/home/vsts/work/1/s/pages/reg.vue?macro=true";
import { default as self_45assessmentc2w7T1Md98Meta } from "/home/vsts/work/1/s/pages/self-assessment.vue?macro=true";
import { default as indexdRMXeAI784Meta } from "/home/vsts/work/1/s/pages/share-bet/index.vue?macro=true";
import { default as streamingF55I7ZZmq8Meta } from "/home/vsts/work/1/s/pages/streaming.vue?macro=true";
import { default as swipe_45betOXwbEQaZ1kMeta } from "/home/vsts/work/1/s/pages/swipe-bet.vue?macro=true";
import { default as switchsiteVmeRkrOBsdMeta } from "/home/vsts/work/1/s/pages/switchsite.vue?macro=true";
import { default as _91toteView_93hTegrICxuRMeta } from "/home/vsts/work/1/s/pages/tote/[toteView].vue?macro=true";
export default [
  {
    name: _91content_93kt1hGsiECfMeta?.name ?? "content",
    path: _91content_93kt1hGsiECfMeta?.path ?? "/:content()",
    meta: _91content_93kt1hGsiECfMeta || {},
    alias: _91content_93kt1hGsiECfMeta?.alias || [],
    redirect: _91content_93kt1hGsiECfMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/[content].vue").then(m => m.default || m)
  },
  {
    name: _91sport_93LQKHQUoxC6Meta?.name ?? "sport",
    path: _91sport_93LQKHQUoxC6Meta?.path ?? "/:sport()",
    children: [
  {
    name: _91sportId_930YbkMQpPA8Meta?.name ?? "sport-sportId",
    path: _91sportId_930YbkMQpPA8Meta?.path ?? ":sportId()",
    children: [
  {
    name: _91fixtureType_93UDHT8Irm3uMeta?.name ?? "sport-sportId-fixtureType",
    path: _91fixtureType_93UDHT8Irm3uMeta?.path ?? ":fixtureType()",
    meta: _91fixtureType_93UDHT8Irm3uMeta || {},
    alias: _91fixtureType_93UDHT8Irm3uMeta?.alias || [],
    redirect: _91fixtureType_93UDHT8Irm3uMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/[sport]/[sportId]/[fixtureType].vue").then(m => m.default || m)
  }
],
    meta: _91sportId_930YbkMQpPA8Meta || {},
    alias: _91sportId_930YbkMQpPA8Meta?.alias || [],
    redirect: _91sportId_930YbkMQpPA8Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/[sport]/[sportId].vue").then(m => m.default || m)
  }
],
    meta: _91sport_93LQKHQUoxC6Meta || {},
    alias: _91sport_93LQKHQUoxC6Meta?.alias || [],
    redirect: _91sport_93LQKHQUoxC6Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/[sport].vue").then(m => m.default || m)
  },
  {
    name: book_45a_45bet_45resultsizdxkyjSHxMeta?.name ?? "book-a-bet-results",
    path: book_45a_45bet_45resultsizdxkyjSHxMeta?.path ?? "/book-a-bet-results",
    meta: book_45a_45bet_45resultsizdxkyjSHxMeta || {},
    alias: book_45a_45bet_45resultsizdxkyjSHxMeta?.alias || [],
    redirect: book_45a_45bet_45resultsizdxkyjSHxMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/book-a-bet-results.vue").then(m => m.default || m)
  },
  {
    name: contact_45usSgGnAosGsWMeta?.name ?? "contact-us",
    path: contact_45usSgGnAosGsWMeta?.path ?? "/contact-us",
    meta: contact_45usSgGnAosGsWMeta || {},
    alias: contact_45usSgGnAosGsWMeta?.alias || [],
    redirect: contact_45usSgGnAosGsWMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: dailyjackpotsKBwsVj15pMMeta?.name ?? "dailyjackpots",
    path: dailyjackpotsKBwsVj15pMMeta?.path ?? "/dailyjackpots",
    meta: dailyjackpotsKBwsVj15pMMeta || {},
    alias: dailyjackpotsKBwsVj15pMMeta?.alias || [],
    redirect: dailyjackpotsKBwsVj15pMMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/dailyjackpots.vue").then(m => m.default || m)
  },
  {
    name: esportsm1R3epktOQMeta?.name ?? "esports",
    path: esportsm1R3epktOQMeta?.path ?? "/esports",
    meta: esportsm1R3epktOQMeta || {},
    alias: esportsm1R3epktOQMeta?.alias || [],
    redirect: esportsm1R3epktOQMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/esports.vue").then(m => m.default || m)
  },
  {
    name: _91sport_93NWFKln68cPMeta?.name ?? "event-sport",
    path: _91sport_93NWFKln68cPMeta?.path ?? "/event/:sport()",
    children: [
  {
    name: _91event_93zk9vV1UzJJMeta?.name ?? "event-sport-region-league-event",
    path: _91event_93zk9vV1UzJJMeta?.path ?? ":region()/:league()/:event()",
    meta: _91event_93zk9vV1UzJJMeta || {},
    alias: _91event_93zk9vV1UzJJMeta?.alias || [],
    redirect: _91event_93zk9vV1UzJJMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/event/[sport]/[region]/[league]/[event].vue").then(m => m.default || m)
  }
],
    meta: _91sport_93NWFKln68cPMeta || {},
    alias: _91sport_93NWFKln68cPMeta?.alias || [],
    redirect: _91sport_93NWFKln68cPMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/event/[sport].vue").then(m => m.default || m)
  },
  {
    name: index5uCpQGhJ8kMeta?.name ?? "event",
    path: index5uCpQGhJ8kMeta?.path ?? "/event",
    meta: index5uCpQGhJ8kMeta || {},
    alias: index5uCpQGhJ8kMeta?.alias || [],
    redirect: index5uCpQGhJ8kMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/event/index.vue").then(m => m.default || m)
  },
  {
    name: healthgO3FPzNA7uMeta?.name ?? "health",
    path: healthgO3FPzNA7uMeta?.path ?? "/health",
    meta: healthgO3FPzNA7uMeta || {},
    alias: healthgO3FPzNA7uMeta?.alias || [],
    redirect: healthgO3FPzNA7uMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/health.vue").then(m => m.default || m)
  },
  {
    name: indexegOWm4p6gtMeta?.name ?? "index",
    path: indexegOWm4p6gtMeta?.path ?? "/",
    meta: indexegOWm4p6gtMeta || {},
    alias: indexegOWm4p6gtMeta?.alias || [],
    redirect: indexegOWm4p6gtMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/index.vue").then(m => m.default || m)
  },
  {
    name: jackpotsFEOKkTz2kEMeta?.name ?? "jackpots",
    path: jackpotsFEOKkTz2kEMeta?.path ?? "/jackpots",
    meta: jackpotsFEOKkTz2kEMeta || {},
    alias: jackpotsFEOKkTz2kEMeta?.alias || [],
    redirect: jackpotsFEOKkTz2kEMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/jackpots.vue").then(m => m.default || m)
  },
  {
    name: liveyTCRxVARCsMeta?.name ?? "live",
    path: liveyTCRxVARCsMeta?.path ?? "/live",
    meta: liveyTCRxVARCsMeta || {},
    alias: liveyTCRxVARCsMeta?.alias || [],
    redirect: liveyTCRxVARCsMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/live.vue").then(m => m.default || m)
  },
  {
    name: _91subLobby_93gQY47dpIVcMeta?.name ?? "lobby-subLobby",
    path: _91subLobby_93gQY47dpIVcMeta?.path ?? "/lobby/:subLobby()",
    children: [
  {
    name: indexWjwOuaJYfCMeta?.name ?? "lobby-subLobby-tab",
    path: indexWjwOuaJYfCMeta?.path ?? ":tab()",
    meta: indexWjwOuaJYfCMeta || {},
    alias: indexWjwOuaJYfCMeta?.alias || [],
    redirect: indexWjwOuaJYfCMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/lobby/[subLobby]/[tab]/index.vue").then(m => m.default || m)
  },
  {
    name: _91game_93agPUsgKOwUMeta?.name ?? "lobby-subLobby-type-game",
    path: _91game_93agPUsgKOwUMeta?.path ?? ":type()/:game()",
    meta: _91game_93agPUsgKOwUMeta || {},
    alias: _91game_93agPUsgKOwUMeta?.alias || [],
    redirect: _91game_93agPUsgKOwUMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/lobby/[subLobby]/[type]/[game].vue").then(m => m.default || m)
  }
],
    meta: _91subLobby_93gQY47dpIVcMeta || {},
    alias: _91subLobby_93gQY47dpIVcMeta?.alias || [],
    redirect: _91subLobby_93gQY47dpIVcMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/lobby/[subLobby].vue").then(m => m.default || m)
  },
  {
    name: loggingLxNRDEOlcmMeta?.name ?? "logging",
    path: loggingLxNRDEOlcmMeta?.path ?? "/logging",
    meta: loggingLxNRDEOlcmMeta || {},
    alias: loggingLxNRDEOlcmMeta?.alias || [],
    redirect: loggingLxNRDEOlcmMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/logging.vue").then(m => m.default || m)
  },
  {
    name: luckynumbersBOOPWjF9J6Meta?.name ?? "luckynumbers",
    path: luckynumbersBOOPWjF9J6Meta?.path ?? "/luckynumbers",
    meta: luckynumbersBOOPWjF9J6Meta || {},
    alias: luckynumbersBOOPWjF9J6Meta?.alias || [],
    redirect: luckynumbersBOOPWjF9J6Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/luckynumbers.vue").then(m => m.default || m)
  },
  {
    name: indexh0yOV4UQKBMeta?.name ?? "outrights",
    path: indexh0yOV4UQKBMeta?.path ?? "/outrights",
    meta: indexh0yOV4UQKBMeta || {},
    alias: indexh0yOV4UQKBMeta?.alias || [],
    redirect: indexh0yOV4UQKBMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/outrights/index.vue").then(m => m.default || m)
  },
  {
    name: regZoxP0uSQu5Meta?.name ?? "reg",
    path: regZoxP0uSQu5Meta?.path ?? "/reg",
    meta: regZoxP0uSQu5Meta || {},
    alias: regZoxP0uSQu5Meta?.alias || [],
    redirect: regZoxP0uSQu5Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/reg.vue").then(m => m.default || m)
  },
  {
    name: self_45assessmentc2w7T1Md98Meta?.name ?? "self-assessment",
    path: self_45assessmentc2w7T1Md98Meta?.path ?? "/self-assessment",
    meta: self_45assessmentc2w7T1Md98Meta || {},
    alias: self_45assessmentc2w7T1Md98Meta?.alias || [],
    redirect: self_45assessmentc2w7T1Md98Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/self-assessment.vue").then(m => m.default || m)
  },
  {
    name: indexdRMXeAI784Meta?.name ?? "share-bet",
    path: indexdRMXeAI784Meta?.path ?? "/share-bet",
    meta: indexdRMXeAI784Meta || {},
    alias: indexdRMXeAI784Meta?.alias || [],
    redirect: indexdRMXeAI784Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/share-bet/index.vue").then(m => m.default || m)
  },
  {
    name: streamingF55I7ZZmq8Meta?.name ?? "streaming",
    path: streamingF55I7ZZmq8Meta?.path ?? "/streaming",
    meta: streamingF55I7ZZmq8Meta || {},
    alias: streamingF55I7ZZmq8Meta?.alias || [],
    redirect: streamingF55I7ZZmq8Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/streaming.vue").then(m => m.default || m)
  },
  {
    name: swipe_45betOXwbEQaZ1kMeta?.name ?? "swipe-bet",
    path: swipe_45betOXwbEQaZ1kMeta?.path ?? "/swipe-bet",
    meta: swipe_45betOXwbEQaZ1kMeta || {},
    alias: swipe_45betOXwbEQaZ1kMeta?.alias || [],
    redirect: swipe_45betOXwbEQaZ1kMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/swipe-bet.vue").then(m => m.default || m)
  },
  {
    name: switchsiteVmeRkrOBsdMeta?.name ?? "switchsite",
    path: switchsiteVmeRkrOBsdMeta?.path ?? "/switchsite",
    meta: switchsiteVmeRkrOBsdMeta || {},
    alias: switchsiteVmeRkrOBsdMeta?.alias || [],
    redirect: switchsiteVmeRkrOBsdMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/switchsite.vue").then(m => m.default || m)
  },
  {
    name: _91toteView_93hTegrICxuRMeta?.name ?? "tote-toteView",
    path: _91toteView_93hTegrICxuRMeta?.path ?? "/tote/:toteView()",
    meta: _91toteView_93hTegrICxuRMeta || {},
    alias: _91toteView_93hTegrICxuRMeta?.alias || [],
    redirect: _91toteView_93hTegrICxuRMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/pages/tote/[toteView].vue").then(m => m.default || m)
  }
]